import type { Setup } from "./useSetups";

const weakOffsetIndex = new WeakMap<Setup, Map<string /*string*/, number /*sigma*/>>();

const getQuantityOffset = (setup: Setup | null, quantityId: string) => {
  if (setup === null) return 0;

  let index = weakOffsetIndex.get(setup);
  if (!index) {
    index = new Map(setup.simulationOutputs.map(input => [input.quantityId, input.offsetExpected]));
    weakOffsetIndex.set(setup, index);
  }

  return index.get(quantityId) ?? 0;
};

export default getQuantityOffset;
